import Slider from "../components/sliderProject";
import NewsPanel from "../components/newsPanel";
import React from 'react';
import { Carousel } from 'antd';

// Banner轮播数据（使用 PUBLIC_URL 确保在开发/生产环境下路径一致）
const bannerData = [
  {
    image: process.env.PUBLIC_URL + "/images/banner2.png",
    title: "First Galactic Center Black Hole",
  },
  {
    image: process.env.PUBLIC_URL + "/images/space_8.gif",
    title: "3D Photography of Satellites",
  },
  {
    image: process.env.PUBLIC_URL + "/images/br.png",
    title: "Quantitative Ultrasound Tomography",
  },
  {
    image: process.env.PUBLIC_URL + "/images/home1.png",
    title: "Microscopic Adaptive Optics",
  },
  {
    image: process.env.PUBLIC_URL + "/images/home3.gif",
    title: "Biomedical Inverse Scattering",
  }
];

const Home = () => {
    return (
        <div>
            {/* Banner轮播区域 - 基于home1图片比例缩放，与news栏宽度一致 */}
            <div className="w-4/5 mx-auto">
              <Carousel autoplay autoplaySpeed={3000} effect="fade" arrows={false} className="custom-banner-carousel">
                {bannerData.map((item, index) => (
                  <div key={index}>
                    {/* ✅ 每一页真正的 Banner 容器 */}
                    <div className="relative w-full aspect-[1970/1000] overflow-hidden">
                      {/* 1️⃣ 模糊背景层（始终铺满） */}
                      <img
                        src={item.image}
                        alt=""
                        className="absolute inset-0 w-full h-full object-cover blur-xl scale-110"
                      />

                      {/* 2️⃣ 半透明遮罩 */}
                      <div className="absolute inset-0 bg-black bg-opacity-30 z-10" />

                      {/* 3️⃣ 前景图：保持比例，自动填充至宽或高与容器一致 */}
                      <div className="absolute inset-0 z-20 flex items-center justify-center">
                        <img
                          src={item.image}
                          alt={`Banner ${index + 1}`}
                          className="w-full h-full object-contain"
                        />
                      </div>

                      {/* 4️⃣ 文本层 */}
                      <div className="absolute inset-0 z-30 flex items-center justify-center px-4">
                        <h1 className="text-white text-lg md:text-3xl lg:text-4xl font-bold drop-shadow-lg text-center">
                          {item.title}
                        </h1>
                      </div>
                    </div>
                  </div>
                ))}
              </Carousel>
            </div>

            {/* 实验室介绍段落：插入在轮播与 Project Highlights 之间 */}
            <div className="w-4/5 mx-auto mt-12 mb-12 text-justify text-lg md:text-xl lg:text-2xl leading-relaxed text-gray-800 px-4">
              <p className="mb-6 font-sans font-medium italic" style={{ fontFamily: 'Arial, sans-serif' }}>
                Computational imaging is a vibrant and rapidly growing field at the intersection of computer science, the physical sciences, and instrumentation. The PKU Computational Scientific Imaging Lab develops next-generation imaging algorithms and hardware to drive scientific discovery across extreme scales. <br></br>The lab is led by He Sun, Assistant Professor of Biomedical Engineering & Biophysics at Peking University.
              </p>
            </div>

            <div className="w-4/5 mx-auto">
                <h2 className="mt-10 text-lg md:text-2xl">Project Highlights</h2>
                <Slider />
            </div>

            <div className="w-4/5 mx-auto mt-8 mb-20">
                <h2 className="mt-10 text-lg md:text-2xl">News</h2>
                <NewsPanel />
            </div>
        </div>
    );
};

export default Home;